module.exports = __webpack_public_path__ + "static/media/yui.c7994f74.png";